import { FaBookOpen } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { PageLinks, UserRolePermissions } from '../../../constants';
import { checkSitePermission } from '../../../store/slices/user';

const AddUpdateBrochure = ({
  handleAddToBrochureClick,
  className,
  isSelected,
  disabled,
  disabledTooltip,
}) => {
  const canSendBrochure = useSelector(checkSitePermission(UserRolePermissions.canSendBrochure));
  const router = useRouter();
  const { travelAgency } = useSelector((state) => state.user);
  const brochureSettings =
    (travelAgency && travelAgency.settings && travelAgency.settings.brochureSettings) || {};
  const displayName = brochureSettings.DisplayName?.toLowerCase() || 'Brochure';
  const displayLabel = isSelected ? `Remove from ${displayName}` : `Add to ${displayName}`;
  const isBrochurePage = router.pathname.indexOf('brochure') > -1;
  const doEnableBrochure =
    canSendBrochure && (router.pathname === PageLinks.Result.url || isBrochurePage);

  const handleClick = (event) => {
    if (disabled) return;
    handleAddToBrochureClick(event);
  };

  return doEnableBrochure ? (
    <div className={`inline-block ${className}`}>
      <a
        role="button"
        tabIndex="-1"
        aria-disabled={disabled}
        title={disabled ? disabledTooltip || undefined : undefined}
        className={`focus:outline-none ${
          disabled ? 'text-gray-400 cursor-not-allowed opacity-50' : 'text-theme cursor-pointer'
        }`}
        onKeyDown={handleClick}
        onClick={handleClick}
      >
        <FaBookOpen className="inline -mt-1" /> {displayLabel}
      </a>
    </div>
  ) : (
    <></>
  );
};

AddUpdateBrochure.propTypes = {
  handleAddToBrochureClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
};

AddUpdateBrochure.defaultProps = {
  className: '',
  disabled: false,
  disabledTooltip: '',
};
export default AddUpdateBrochure;
